/**
 * Staff "view as client / sponsor". useMatter owns the flag in React; this
 * module is the framework-free way to read it, from the same sessionStorage
 * key useMatter maintains via setImpersonating().
 *
 * History worth keeping: from 2026-07-23 (Jane's 600 review, BUG-1) this flag
 * made preview strictly read-only, because an edit inside a preview autosaved
 * into the client's real intake data and RLS permits staff writes, so only the
 * portal could refuse them. Tzvi reversed that on 2026-08-03: staff may edit
 * any field from any view, since fixing a client's typo in the client's own
 * view is the natural way to do it, and previewing is also how staff reproduce
 * what a client reports. The write choke points now use this flag to ATTRIBUTE
 * the write in audit_log rather than to block it.
 */
export const IMPERSONATE_KEY = 'adi_portal_impersonate_v1';
export const IMPERSONATE_ROLE_KEY = 'adi_portal_impersonate_role_v1';

/**
 * Drop the preview flag entirely. sessionStorage survives sign-out, so
 * without this a staff member who previewed as a client and then logged
 * back in as a real client in the same tab kept the flag: every field inert,
 * every save refused, and no banner to explain it (ImpersonationBanner is
 * gated on actuallyStaff, which a real client is not). Tzvi, 2026-08-03.
 */
export function clearImpersonation(): void {
  try {
    sessionStorage.removeItem(IMPERSONATE_KEY);
    sessionStorage.removeItem(IMPERSONATE_ROLE_KEY);
  } catch {
    /* ignore */
  }
}

/** True while the signed-in user is previewing as a client or sponsor. */
export function isImpersonationPreview(): boolean {
  try {
    return sessionStorage.getItem(IMPERSONATE_KEY) != null;
  } catch {
    return false;
  }
}
